<template>
	<slot
		:value="value"
		:checked="checked"
		:meta="meta"
		:handle-change="handleChange"
	></slot>
</template>

<script setup>
import { computed } from 'vue'
import { useField } from 'vee-validate';
import * as yup from 'yup';

const props = defineProps({
	name: String,
	value: String,
	validatorString: String
});

// Create validator function from string
const validator = computed(() => {
    return new Function('yup', `return ${props.validatorString}`)(yup);
});

const { meta, handleChange, checked } = useField(() => props.name, validator, {
	type: 'checkbox',
	checkedValue: props.value,
});
</script>
